<div class="form-group">
  @if (!hideLabel) {
    <label class="form-label">{{ label }}</label>
  }
  <div>
    @for (item of items; track $index; let i = $index) {
      <span class="badge rounded-pill" [ngClass]="isReadonly ? 'disabled-look' : 'text-bg-primary'">
        <span class="truncate keep-whitespace">{{ item }}</span>
        @if (!isReadonly) {
          <span class="clickable ms-1">
            <fa-icon [fixedWidth]="true" [icon]="'times-circle'" (click)="remove(i)"/>
          </span>
        }
      </span>
    }
  </div>
  @if (!isReadonly) {
    <div class="mt-2">
      <input type="text" [placeholder]="placeholder" [formControl]="formControl"
             (keydown.enter)="$event.preventDefault()" (keyup.enter)="add();" (focus)="onFocus()" (blur)="onBlur()"  >
    </div>
  }
</div>
